/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, ReactElement } from 'react';
import { cn } from 'src/domains/common/components/utils';
import { observer } from 'src/utils/mobx-react';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

interface InputPropsType extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: React.ReactNode;
    dataTest?: string;
    formInputState: FormInputState<string, unknown>;
    description?: string;
    errors: string[];
}

export const Input: FC<InputPropsType> = observer(
    'Input',
    ({ label, formInputState, className, description, dataTest, errors, onChange, ...props }): ReactElement => {
        const error = errors.length === 0 ? null : (errors[0] ?? null);
        return (
            <div className='flex flex-col flex-auto gap-2'>
                {label !== undefined && <label className='text-sm'>{label}</label>}
                <input
                    value={formInputState.value}
                    onChange={(e): void => {
                        if (typeof onChange === 'function') {
                            onChange(e);
                        }
                        formInputState.setValueOnChange(e.target.value);
                    }}
                    onBlur={formInputState.setAsVisited}
                    className={cn(
                        'flex h-9 w-full rounded-md border border-solid border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-zinc-400 disabled:cursor-not-allowed disabled:opacity-50',
                        error === null ? '' : 'border-destructive',
                        className
                    )}
                    data-test={dataTest}
                    {...props}
                />
                {description !== undefined && error === null && (
                    <span className='text-sm text-muted-foreground'>{description}</span>
                )}
                {error === null ? null : <span className='text-sm text-destructive'>{error}</span>}
            </div>
        );
    }
);
